import { ArrowLeft, ArchiveRestore, Loader2, Trash2 } from "lucide-react";
import { Button } from "../ui/button";

export const LightRecipeTrash = ({ items, loading, restoringId, onBack, onRestore }) => (
  <section className="space-y-4" data-testid="light-recipe-trash">
    <div className="flex items-center gap-3">
      <Button variant="ghost" size="icon" onClick={onBack} aria-label="Torna alle ricette"
        data-testid="light-trash-back"><ArrowLeft className="h-4 w-4" /></Button>
      <div>
        <h3 className="font-semibold">Cestino ricette Light</h3>
        <p className="text-xs text-muted-foreground">I lotti creati restano consultabili.</p>
      </div>
    </div>
    {loading ? <p className="text-sm text-muted-foreground" data-testid="light-trash-loading">Caricamento...</p>
      : items.length === 0 ? (
        <div className="py-10 text-center text-muted-foreground" data-testid="light-trash-empty">
          <Trash2 className="h-6 w-6 mx-auto mb-2" />Nessuna ricetta nel Cestino
        </div>
      ) : items.map(item => (
        <div key={item.id} className="flex items-center gap-3 border-b border-border py-3" data-testid={`light-trash-item-${item.id}`}>
          <div className="min-w-0 flex-1">
            <p className="truncate font-medium text-sm">{item.nome}</p>
            {item.archived_at && <p className="text-xs text-muted-foreground">Eliminata il {new Date(item.archived_at).toLocaleDateString("it-IT")}</p>}
          </div>
          <Button variant="outline" size="sm" onClick={() => onRestore(item)} disabled={!!restoringId}
            data-testid={`light-trash-restore-${item.id}`}>
            {restoringId === item.id ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <ArchiveRestore className="h-4 w-4 mr-1" />}
            Ripristina
          </Button>
        </div>
      ))}
  </section>
);